import { createUseStyles } from 'react-jss'
import { ORANGE, TANGERINE_ORANGE } from '@omnilert/components'

export default createUseStyles({
  primaryButton: {
    margin: '15px 0'
  },
  primaryButtonTitle: {
    fontSize: '18px'
  },
  contactList: {
    margin: '0 !important'
  },
  smsDescriptionText: {
    marginTop: '-10px !important',
    marginBottom: '15px !important'
  },
  contactsDisclaimerText: {
    textAlign: 'center',
    marginTop: '15px !important'
  },
  icon: {
    opacity: 0.6,
    padding: '20px',
    '& path': {
      fill: ({ duration }) => duration ? 'url(#warning)' : 'url(#info)'
    }
  },
  noContactsWrapper: {
    margin: '15px 0',
    '& :first-child': {
      marginBottom: '15px'
    }
  },
  responsive: {
    alignItems: 'center',
    backgroundColor: 'var(--secondary__page__background__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '100% !important',
    padding: '0 20px',
    position: 'relative',
    width: '100% !important',
    overflowY: 'auto'
  },
  setTimeButton: {
    '&:hover': {
      color: TANGERINE_ORANGE,
      cursor: 'pointer'
    },
    background: 'transparent',
    border: 'none',
    color: ORANGE,
    fontSize: '18px',
    fontWeight: 'bold',
    textDecoration: 'none',
    userSelect: 'none'
  }
})

